import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { AbErrorDialog } from "abreact/incubator/ui/error/AbErrorDialog";
import { LogUtils } from "abweb/utils/log/LogUtils";
import { reaction } from "mobx";
export class ReactErrorRenderer {
  constructor() {
    // nop
  }
  handleErrorContext(errCtx, onComplete) {
    this.displayError(errCtx.error, onComplete);
  }
  displayError(error, onComplete) {
    ReactErrorRenderer.LOGGER().debug("Displaying error: " + error);
    if (this._dialogMachine) {
      ReactErrorRenderer.LOGGER().debug("  adding to existing renderer");
      this._dialogMachine.addError(error);
      return;
    }
    ReactErrorRenderer.LOGGER().debug("  displaying new renderer");
    this._dialogMachine = AbErrorDialog.displayErrorWithoutUpdatingLastError(error);
    // Call the onComplete callback once the error dialog completes.
    this._machineDisposer = reaction(() => this._dialogMachine.complete, complete => {
      if (complete) {
        ReactErrorRenderer.LOGGER().debug("Closing error renderer");
        this._dialogMachine = null; // dialogMachine.destroy() has already been invoked.  see CAT-1409
        this._machineDisposer();
        if (onComplete) {
          onComplete();
        }
      }
    });
  }
}
_defineProperty(ReactErrorRenderer, "LOGGER", () => LogUtils.getLogger(__filename));
//# sourceMappingURL=ReactErrorRenderer.js.map
